<template>
    <v-container fluid>
        <v-row
            align="start"
            no-gutters
            v-masonry
        >



            <!---=-=-=-=Reports-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-show="isAnyReports"
                xl="4"
                v-if="accessCrud.length > 0"
            >
                <Reports
                    :access-crud="accessCrud"
                    @reports="areAnyReportsAvailable"
                    @hook:mounted="redrawMasonry"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Reports from "../components/widgets/Reports";
export default {
    name: "Dashboard",
    data: () => ({
        accessCrud: [],
        isAnyReports: true
        //
    }),
    created: async function() {
        this.accessCrud = await this.$store.dispatch(
            "authentication/getAccess"
        );
    },
    mounted: function() {
        this.$redrawVueMasonry();
    },
    components: {

        Reports,
    },
    methods: {
        areAnyReportsAvailable(areAnyReportsAvailable) {
            this.isAnyReports = areAnyReportsAvailable;
        },
        redrawMasonry() {
            this.$redrawVueMasonry();
        }
        //--------------------
    }
};
</script>

<style lang="stylus" scoped>
c-square-w = 55px;
c-ssquare-w = 85px;

/deep/.status-stat {
    width: c-ssquare-w;
    height: c-ssquare-w;
}

/deep/.ageing-stat {
    width: c-square-w;
    height: c-square-w;

    .header {
        position: absolute;
        left: 4px;
        top: 0px;
    }

    .stat {
        margin-top: 5px;
        line-height: c-square-w;
    }
}

/deep/.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

/deep/.theme--dark {
    .base-background {
        background: #121212;
    }
}

/*
/deep/.dashboard-card
    background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1))
*/
</style>
